__turbopack_context__.v({
  "active": "NavigationFooter-module-scss-module__wsR7kG__active",
  "container": "NavigationFooter-module-scss-module__wsR7kG__container",
  "icon": "NavigationFooter-module-scss-module__wsR7kG__icon",
  "label": "NavigationFooter-module-scss-module__wsR7kG__label",
  "tab": "NavigationFooter-module-scss-module__wsR7kG__tab",
});
